import React, { useRef } from 'react';
import { TextInput, FormControl, Button, Stack } from '@primer/react';
import { CalendarIcon } from '@primer/octicons-react'

interface DateInputProps {
    value: string;
    onChange: (value: string) => void;
    type?: 'from' | 'to';
    placeholder?: string;
    className?: string;
    disabled?: boolean;
    minDate?: string;
    maxDate?: string;
}

const DateInput: React.FC<DateInputProps> = ({
    value,
    onChange,
    type = 'from',
    placeholder,
    className = '',
    disabled = false,
    minDate,
    maxDate
}) => {
    const dateInputRef = useRef<HTMLInputElement>(null);

    const formatDisplayDate = (dateString: string): string => {
        if (!dateString) return '';

        try {
            const date = new Date(dateString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = String(date.getFullYear()).slice(-2);

            const prefix = type === 'from' ? 'От ' : 'До ';
            return `${prefix}${day}.${month}.${year}`;
        } catch {
            return '';
        }
    };

    const getPlaceholder = (): string => {
        if (placeholder) return placeholder;
        return type === 'from' ? 'От' : 'До';
    };

    return (
        <div className={`relative ${className} ${(value && value.trim() ? 'border-none' : 'border border-border')} rounded-md`}>
            <TextInput
                ref={dateInputRef}
                type="date"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                min={minDate}
                max={maxDate}
                disabled={disabled}
                contrast={!!(value && value.trim())}
                className="absolute opacity-0 pointer-events-none border "
            />
            <Button
                onClick={() => dateInputRef.current?.showPicker?.() || dateInputRef.current?.focus()}
                leadingVisual={CalendarIcon}
                disabled={disabled}
                variant={value?.trim() ? 'default' : 'invisible'}
                style={{ height: '40px' }}
                sx={{ //Увеличение длины кнопки с сохранением выравнивания текста и иконки
                    width: '100%',
                    px: 3,
                    '& > span': {
                        justifyContent: 'flex-start !important',
                        textAlign: 'left',
                        width: '100%',
                    },
                }}
            >
                <span className="w-full text-left">
                    {value ? formatDisplayDate(value) : (
                        <span className="text-gray-500">{getPlaceholder()}</span>
                    )}
                </span>
            </Button>


        </div>
    );
};

export { DateInput }